import JGridIndexActions from "./JGridIndexActions";

export { JGridIndexActions }
export default JGridIndexActions
